import { useContext, useEffect, useMemo } from 'react';

import { GlobalContext } from '../../../../providers/global-provider';
import {
  DATA_DISPLAY_KEYS,
  ExchangeType,
  PORTFOLIO_TABS_KEYS,
  PortfolioManagementContext,
} from '../../../../providers/portfolio-management';
import { accountTabsConfig, aggregatedTabs } from '../../config/account-tabs-config';
import './styles.scss';

export const PortfolioTabsBase = () => {
  const { portfolioCurrentTab, setPortfolioCurrentTab } = useContext(GlobalContext);
  const { accountTabs, selectedAccountOption, selectedDataDisplayOption, setAccountTabs } =
    useContext(PortfolioManagementContext);

  const isPerAccount = selectedDataDisplayOption === DATA_DISPLAY_KEYS.perAccount;

  const accStateKey = isPerAccount
    ? `${selectedAccountOption.name}_${selectedDataDisplayOption}`
    : selectedDataDisplayOption;

  const handleTabChange = (newTab: string) => {
    setPortfolioCurrentTab(newTab);
    setAccountTabs((prevTabs) => ({
      ...prevTabs,
      [accStateKey]: newTab,
    }));
  };

  const visibleTabKeys = useMemo(() => {
    if (isPerAccount) {
      return accountTabsConfig[selectedAccountOption.exchange as ExchangeType].perAccount;
    }
    return aggregatedTabs;
  }, [selectedAccountOption.exchange, isPerAccount]);

  const portfolioVisibleTabs = useMemo(() => {
    return PORTFOLIO_TABS_KEYS.filter((tab) => visibleTabKeys.includes(tab.key));
  }, [visibleTabKeys]);

  useEffect(() => {
    setPortfolioCurrentTab(accountTabs[accStateKey] || visibleTabKeys[0]);
  }, [selectedAccountOption, accountTabs, selectedDataDisplayOption, visibleTabKeys]);

  const renderTabs = useMemo(() => {
    return portfolioVisibleTabs.map((tab, index) => {
      const isSelected = portfolioCurrentTab === tab.key;
      return (
        <div
          key={`${index}_${tab.key}`}
          className={`tab ${isSelected ? 'tab-selected' : ''}`}
          onClick={() => handleTabChange(tab.key)}
        >
          <div className="portfolio-tabs-base-content">
            <span>{tab.label}</span>
          </div>
        </div>
      );
    });
  }, [portfolioVisibleTabs, portfolioCurrentTab, handleTabChange]);

  return (
    <div className="portfolio-tabs-base-container">
      {renderTabs}
      <div className="tabs-border-fill"></div>
    </div>
  );
};
